// BAND-AID SOLUTION
// SUBSCRIBER SHOULD BE MADE INTO IT"S OWN MODULE

import LockeSubscriptionForm from '../../../Vue/Custom/Site/LockeSubscriptionForm.vue';
import VueModal from '../../../Vue/Core/Global/Components/VueModals/VueModal.vue';
import VueInput from '../../../Vue/Core/Global/Components/VueForms/VueInput.vue';
import Vue from 'vue';

window.addEventListener('load', function() {
    const sidebar = document.querySelector('.blog-sidebar');

    this.setTimeout(function() {
        if (sidebar) {
            const ComponentConstructor = Vue.extend(LockeSubscriptionForm);
            const componentInstance = new ComponentConstructor({
                propsData: {view:'Blog'},
                components: {
                    VueModal,
                    VueInput,
                }
            })

            let nextNode = sidebar.childNodes[0];
            let mountEl = document.createElement('div');
            mountEl.id = 'mount-el';
            sidebar.insertBefore(mountEl, nextNode);

            componentInstance.$mount('#mount-el');
        }
    }, 0);
})